import { Box, Typography } from '@mui/material';
import { Accordion } from 'src/components/UI/Accordion';
import { TextArea } from 'src/components/UI/TextArea';
import { Controller, useFormContext } from 'react-hook-form';
import {
  businessDetailsDescriptionSx,
  campaignNotesExampleContainerSx,
  campaignNotesExampleTextFirstSx,
  campaignNotesExampleTextSecondSx
} from '../../styles/createCampaign';
import { ConfirmAndPayFormData } from './index';

// Constants
const CAMPAIGN_NOTES_TITLE = 'Campaign Notes';
const DESCRIPTION_TEXT =
  "Have any notes or special instructions for our submissions team? Let us know below if there's anything we should be aware of before submitting to directories.";
const TEXTAREA_LABEL = 'Campaign Notes (Optional)';
const TEXTAREA_PLACEHOLDER = 'Leave your notes for us here';
const MAX_LENGTH = 1000;

const EXAMPLE_TEXT_PARTS = [
  'Example: This business has two other locations in town — 58 Willow Lane and Suite 3, 2190 Parker Avenue. Please do not update citations for these addresses.',
  "Also, some existing listings may appear under a different name, 'Greenview Dental' — please check for these and update accordingly. Thank you!"
] as const;

export const CampaignNotes = () => {
  const {
    control,
    formState: { errors }
  } = useFormContext<ConfirmAndPayFormData>();

  return (
    <Accordion title={CAMPAIGN_NOTES_TITLE} defaultExpanded={true}>
      <Typography sx={businessDetailsDescriptionSx}>
        {DESCRIPTION_TEXT}
      </Typography>

      <Controller
        name="campaignNotes"
        control={control}
        render={({ field }) => (
          <TextArea
            value={field.value || ''}
            onChange={(value) => field.onChange(value)}
            maxLength={MAX_LENGTH}
            label={TEXTAREA_LABEL}
            placeholder={TEXTAREA_PLACEHOLDER}
            error={!!errors.campaignNotes}
            helperText={errors.campaignNotes?.message}
          />
        )}
      />

      <Box sx={campaignNotesExampleContainerSx}>
        <Typography sx={campaignNotesExampleTextFirstSx}>
          {EXAMPLE_TEXT_PARTS[0]}
        </Typography>
        <Typography sx={campaignNotesExampleTextSecondSx}>
          {EXAMPLE_TEXT_PARTS[1]}
        </Typography>
      </Box>
    </Accordion>
  );
};
